import React, {useEffect, useState} from "react";
import {Resource} from "../models/Resource";
import {getDownloadURL, ref} from "firebase/storage";
import {storage} from "../util/Firebase";
import {useGlobalState} from "../GlobalState";

export const ResourcePDF: React.FC<{ resource: Resource }> = ({resource}) => {
    const { isPremium } = useGlobalState();
    const [fileUrl, setFileUrl] = useState<string | null>(null);

    useEffect(() => {
        const fileRef = ref(storage, `resources/${resource.fileUrl}`);
        getDownloadURL(fileRef).then((url: string) => {
            setFileUrl(url);
        }).catch((error: Error) => {
            console.error("Error fetching resource URL:", error);
        });
    });
    return (
        <div className='resource-pdf-section'>
            {((!resource.isPremium || isPremium) && fileUrl) && (
                <iframe
                    className={`resource-pdf-content`}
                    src={fileUrl}
                    title={`${resource.name} document viewer`}
                />
            )}
        </div>
    )
}